"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Utilities = require("../../Utilities");

var _Validations = require("../../Validations");

var _Elements = require("../../Components/Elements");

var _Form = require("../../Form");

var _Components = require("../../Components");

var _Loading = _interopRequireDefault(require("../../../Loading"));

var _circleCheck = _interopRequireDefault(require("../../../../assets/icons/circle-check.svg"));

var _circleClose = _interopRequireDefault(require("../../../../assets/icons/circle-close.svg"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Keywords = function Keywords(_ref) {
  var subLabel = _ref.subLabel,
      value = _ref.value,
      name = _ref.name,
      onChange = _ref.onChange,
      isRequired = _ref.isRequired,
      placeholder = _ref.placeholder,
      id = _ref.id,
      label = _ref.label,
      suggestionsLabel = _ref.suggestionsLabel,
      loadingLabel = _ref.loadingLabel,
      allUsedLabel = _ref.allUsedLabel,
      noneAvailableLabel = _ref.noneAvailableLabel,
      validations = _ref.validations,
      submitAttempted = _ref.submitAttempted;
  var text = value.text,
      keywords = value.keywords,
      suggestions = value.suggestions;

  var getTextInput = function getTextInput(update) {
    onChange({
      name: name,
      value: _objectSpread(_objectSpread({}, value), {}, {
        text: update.value
      })
    });
  };

  var removeKeyword = function removeKeyword(keyword) {
    var newKeywords = keywords.filter(function (word) {
      return word !== keyword;
    });
    onChange({
      name: name,
      value: _objectSpread(_objectSpread({}, value), {}, {
        keywords: newKeywords
      })
    });
  };

  var setKeyword = function setKeyword(keyword) {
    if (!keyword) return;

    var val = _objectSpread({}, value);

    val.keywords.push(keyword);

    if (val.text === keyword) {
      val.text = '';
    } else {
      val.suggestions = val.suggestions.filter(function (word) {
        return word !== keyword;
      });
      if (val.suggestions.length === 0) val.suggestions = false;
    }

    onChange({
      name: name,
      value: val
    });
  };
  /* eslint-disable max-len */


  var buildKeywords = function buildKeywords(theKeywords) {
    return theKeywords.map(function (val) {
      return /*#__PURE__*/_react["default"].createElement(_Components.Pill, {
        label: val,
        onClick: removeKeyword,
        key: val,
        removeIcon: true
      });
    });
  };

  var buildSuggestions = function buildSuggestions(theSuggestions) {
    return theSuggestions.map(function (val) {
      return /*#__PURE__*/_react["default"].createElement(_Components.Pill, {
        primary: true,
        label: val,
        onClick: setKeyword,
        key: val,
        addIcon: true
      });
    });
  };
  /* eslint-enable max-len */

  /*
   * Precedence for the suggestion component state:
   * 1. If suggestions is null, the 'no suggestions' state is shown
   * 2. If suggestions is false, the 'all used' state is shown
   * 3. If suggestions is empty, the loading state is shown
   * 4. Suggestions is an array of strings, it builds the pills
   *
   * If you load suggestions dynamically and input them via the `populate` ref, pass `null` to
   * the suggestions value for the state if you get back no suggestions from the service.
   *
   * The component will automatically set the 'all used' state if all the suggestions are used.
   */


  var suggestionsPart = null;

  if (suggestions === null) {
    suggestionsPart = /*#__PURE__*/_react["default"].createElement("div", {
      "aria-label": "No suggestions available."
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-box"
    }, " ", /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      uniquifyIDs: true,
      cacheRequests: true,
      src: _circleClose["default"]
    }), " ", noneAvailableLabel));
  } else if (suggestions === false) {
    suggestionsPart = /*#__PURE__*/_react["default"].createElement("div", {
      "aria-label": "All suggestions selected."
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-box"
    }, " ", /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      uniquifyIDs: true,
      cacheRequests: true,
      src: _circleCheck["default"]
    }), " ", allUsedLabel));
  } else if (suggestions.length === 0) {
    suggestionsPart = /*#__PURE__*/_react["default"].createElement("div", {
      "aria-label": "Suggestions loading."
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "loading-box"
    }, /*#__PURE__*/_react["default"].createElement(_Loading["default"], null), " ", loadingLabel));
  } else {
    suggestionsPart = /*#__PURE__*/_react["default"].createElement("div", {
      "aria-labelledby": "".concat(id, "-suggestions-label")
    }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
      name: name,
      id: "".concat(id, "-suggestions-label"),
      label: suggestionsLabel
    }), buildSuggestions(suggestions));
  }

  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  return /*#__PURE__*/_react["default"].createElement(_Elements.SelectorWrapper, {
    role: "group",
    id: id,
    "aria-describedby": "".concat(id, "-sublabel"),
    "aria-labelledby": "".concat(id, "-label"),
    name: name,
    className: errorId ? 'form-error' : ''
  }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    name: "".concat(name, "-label"),
    id: "".concat(id, "-label"),
    isRequired: isRequired,
    label: label,
    htmlFor: "".concat(id, "-textinput")
  }), /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    className: "sublabel",
    name: "".concat(name, "-sublabel"),
    id: "".concat(id, "-sublabel"),
    label: subLabel
  }), /*#__PURE__*/_react["default"].createElement(_Elements.SelectorBox, null, /*#__PURE__*/_react["default"].createElement(_Components.GenericInput, {
    placeholder: placeholder,
    name: "".concat(name, "-textinput"),
    id: "".concat(id, "-textinput"),
    attr: {
      'aria-label': placeholder,
      onKeyDown: function onKeyDown(e) {
        // eslint-disable-next-line no-unused-expressions
        e.which === 13 && e.preventDefault(); // eslint-disable-next-line no-unused-expressions

        e.which === 13 && setKeyword(text);
      }
    },
    onChange: getTextInput,
    value: text
  }), /*#__PURE__*/_react["default"].createElement("div", null, buildKeywords(keywords)), suggestionsPart), /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    id: errorId
  }));
};

Keywords.propTypes = {
  subLabel: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  submitAttempted: _propTypes["default"].bool.isRequired,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  isRequired: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]),
  loadingLabel: _propTypes["default"].string,
  allUsedLabel: _propTypes["default"].string,
  noneAvailableLabel: _propTypes["default"].string,
  suggestionsLabel: _propTypes["default"].string,
  initialValue: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    keywords: _propTypes["default"].arrayOf(_propTypes["default"].string),
    suggestions: _propTypes["default"].arrayOf(_propTypes["default"].string)
  }),
  value: _propTypes["default"].shape(),
  validations: _propTypes["default"].shape()
};
Keywords.defaultProps = {
  initialValue: {
    text: '',
    keywords: [],
    suggestions: []
  },
  label: 'forms.default.keywords.label',
  loadingLabel: 'forms.default.keywords.loadingLabel',
  subLabel: 'forms.default.keywords.subLabel',
  allUsedLabel: 'forms.default.keywords.allUsedLabel',
  noneAvailableLabel: 'forms.default.keywords.noneAvailableLabel',
  suggestionsLabel: 'forms.default.keywords.suggestionsLabel',
  placeholder: '',
  isRequired: false,
  value: {
    text: '',
    keywords: [],
    suggestions: []
  },
  validations: {}
};
Keywords.Validations = {
  required: _objectSpread(_objectSpread({}, _Validations.required), {}, {
    fn: function fn(value) {
      return value.keywords.length === 0;
    }
  }),
  minimum: {
    errorMessageId: 'forms.error.minimum.keywords',
    fn: function fn(value) {
      return value.keywords.length < 5;
    }
  }
};

var _default = (0, _Form.asFormElement)(Keywords);

exports["default"] = _default;